import * as React from "react"
const IconLines = ({ width, height, fill }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 57.24 91.61"
        width={width}
        height={height}
        fill={fill}
    >
        <path
            d="M56.39 90.76V.85M48.46 90.76V.85M40.52 90.76V.85M32.59 90.76V.85M24.65 90.76V.85M16.72 90.76V.85M8.79 90.76V.85M.85 90.76V.85"
            style={{
                fill: "none",
                stroke: "#333e69",
                strokeLinecap: "square",
                strokeMiterlimit: 10,
                strokeWidth: "1.7px",
            }}
        />
    </svg>
)
export default IconLines
